const baseURL = process.env.REACT_APP_BASE_URL;
const localimgpath = {
  userImage: `${baseURL}/uploads/user/image`,
  talentThumbnail: `${baseURL}/uploads/talent/thumbnail`,
  eventsThumbnail: `${baseURL}/uploads/events/thumbnail`,
  categoryIcons: `${baseURL}/uploads/category/icons`,
  eventsGallery: `${baseURL}/uploads/events/gallery`,
  eventsBanner: `${baseURL}/uploads/events/banner`,
  newsThumbnail: `${baseURL}/uploads/news/thumbnail`,
  newsBanner: `${baseURL}/uploads/news/banner`,
  talentGallery: `${baseURL}/uploads/talent/gallery`,
  talentDrama: `${baseURL}/uploads/talent/drama`,
  talentVideo: `${baseURL}/uploads/talent/video`,
  talentBanner: `${baseURL}/uploads/talent/banner`,
  talentTopImage: `${baseURL}/uploads/talent/top_image`,
  projectsThumbnail: `${baseURL}/uploads/projects/thumbnail`,
  projectsGallery: `${baseURL}/uploads/projects/gallery`,
  projectsBanner: `${baseURL}/uploads/projects/banner`,
  projectsDrama: `${baseURL}/uploads/projects/drama`,
  projectsVideo: `${baseURL}/uploads/mission_she/video`,
  mission_sheThumbnail: `${baseURL}/uploads/mission_she/thumbnail`,
  mission_sheGallery: `${baseURL}/uploads/mission_she/gallery`,
  mission_sheBanner: `${baseURL}/uploads/mission_she/banner`,
  mission_sheDrama: `${baseURL}/uploads/mission_she/drama`,
  mission_sheVideo: `${baseURL}/uploads/mission_she/video`,
  teamAvatar: `${baseURL}/uploads/teams/avatar`,
  usersProfile: `${baseURL}/uploads/users/profile`,
  companyLogo: `${baseURL}/uploads/employer/logo`,
};
export default localimgpath;
